import { useTranslation } from "react-i18next";
import { Pill } from "@foris/avocado-suite";
import styles from "./proposalSectionPill.module.scss";

/** Marks a section of the form whose value comes from the proposal and differs from Darwin's. */
const ProposalSectionPill = () => {
  const { t } = useTranslation();

  return (
    <Pill className={styles.proposalSectionPill} color="warning-opacity" textColor="warning-60">
      {t("assignation-edit.proposal.section-pill")}
    </Pill>
  );
};

export default ProposalSectionPill;
